import { LOCAL_STORAGE_KEY } from "./constants";

const isDismissed = () => {
  try {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);

    if (!stored) return false;

    return Number(stored) > Date.now();
  } catch (_) {
    return false;
  }
};

export default isDismissed;
